// You can write your custom Javascript here
jQuery(document).ready(function( $ ) {
  
  $('.product__form').on('change', function(){
    var test= $(this).find('.form__btn').text();
    if($(this).find('.form__btn').text() == 'Unavailable'){
     	$('#product .product__images .sold-out-banner').addClass('active');
    }
    else if($(this).find('.form__btn').text() != 'Unavailable'){
    	$('#product .product__images .sold-out-banner').removeClass('active');
    }
    else {
      
  }
});
  
});